enum ContactTypes {
  Company = 'company',
  Person = 'person',
}

export default ContactTypes;
